import axios from '@/axios'
import { getMessageFromError } from '@/utils/functions'

export default {
  getProductCategories: async ({ commit }, payload) => {
    commit('SET_STATE', {
      action: 'category-loading',
      data: true
    })
    try {
      const res = await axios.get('/product-category', {
        params: payload
      })
      commit('SET_STATE', {
        action: 'category-loading',
        data: false
      })
      commit('SET_STATE', {
        action: 'product-categories',
        data: res.data.data
      })
      commit('SET_STATE', {
        action: 'category-total',
        data: res.data.totalCount
      })
      commit('SET_STATE', {
        action: 'category-FilteredCount',
        data: res.data.filteredCount
      })
      return {
        data: res.data.data,
        FilteredCount: res.data.filteredCount,
        totalCount: res.data.totalCount
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'category-loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  getAllProductCategories: async ({ commit }, payload) => {
    const { is_global, is_status } = payload
    commit('SET_STATE', {
      action: 'category-loading',
      data: true
    })
    try {
      const res = await axios.get('/product-category', {
        params: {
          limit: 0,
          page: 1,
          order: ['id', 'ASC'],
          is_global,
          is_status
        }
      })

      return {
        data: res.data.data.map(cat => ({ value: cat.id, label: cat.category_name })),
        message: res.data.message
      }
    } catch (err) {
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  insertCategory: async ({ commit }, payload) => {
    commit('SET_STATE', {
      action: 'category-loading',
      data: true
    })
    try {
      const res = await axios.post('/product-category', payload)
      commit('SET_STATE', {
        action: 'category-loading',
        data: false
      })
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'category-loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  updateCategory: async ({ commit }, { id, data }) => {
    commit('SET_STATE', {
      action: 'category-loading',
      data: true
    })
    try {
      const res = await axios.put(`/product-category/${id}`, data)
      commit('SET_STATE', {
        action: 'category-loading',
        data: false
      })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'category-loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({ message })
    }
  },

  getCategoryId: async ({ commit }, id) => {
    try {
      const res = await axios.get(`/product-category/${id}`)
      commit('SET_STATE', {
        action: 'category-loading',
        data: res.data.data
      })
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (err) {
      const { message } = getMessageFromError(err)
      return Promise.reject({ message })
    }
  },

  deleteProductCategory: async ({ commit }, id) => {
    commit('SET_STATE', {
      action: 'category-loading',
      data: true
    })
    try {
      const res = await axios.delete(`/product-category/${id}`)
      commit('SET_STATE', {
        action: 'category-loading',
        data: false
      })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'category-loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  categoryStatusUpdate: async ({ commit }, { id, status }) => {
    commit('SET_STATE', {
      action: 'category-loading',
      data: true
    })
    try {
      const res = await axios.put(`/product-category/${id}/update-status`, { status })
      commit('SET_STATE', {
        action: 'category-loading',
        data: false
      })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'category-loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  getProductList: async ({ commit }, payload) => {
    const { limit, page, order, search } = payload
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await axios.get('/product', {
        params: {
          limit,
          page,
          search,
          order
        }
      })
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      commit('SET_STATE', {
        action: 'products',
        data: res.data.data
      })
      commit('SET_STATE', {
        action: 'total',
        data: res.data.totalCount
      })
      commit('SET_STATE', {
        action: 'FilteredCount',
        data: res.data.filteredCount
      })
      return {
        data: res.data.data,
        FilteredCount: res.data.filteredCount,
        totalCount: res.data.totalCount
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  deleteProduct: async ({ commit }, id) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await axios.delete(`/product/${id}`)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  quantityEdit: async (_, { id, data }) => {
    try {
      // update product quantity
      const res = await axios.put(`product/update-product-quantity/${id}`, data)
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (err) {
      const { message } = getMessageFromError(err)
      return Promise.reject({ message })
    }
  },

  updateProductStatus: async ({ commit }, { id, status }) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await axios.put(`/product/${id}/update-status`, { status })
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },
  getProductHistoricalList: async ({ commit }, { id, data }) => {
    commit('SET_STATE', {
      action: 'product-loading',
      data: true
    })
    try {
      const res = await axios.get(`product/${id}/product-history`, {
        params: data
      })
      commit('SET_STATE', {
        action: 'product-loading',
        data: false
      })
      commit('SET_STATE', {
        action: 'product-historical',
        data: res.data.data
      })
      commit('SET_STATE', {
        action: 'product-total',
        data: res.data.totalCount
      })
      commit('SET_STATE', {
        action: 'product-FilteredCount',
        data: res.data.filteredCount
      })
      return {
        data: res.data.data,
        FilteredCount: res.data.filteredCount,
        total: res.data.totalCount
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'product-loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject(message)
    }
  },
  updateQuantity: async (_, { id, data }) => {
    try {
      const res = await axios.put(`product/${id}/update-quantity`, data)
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (err) {
      const { message } = getMessageFromError(err)
      return Promise.reject({ message })
    }
  },
  updateHistoryQuantity: async (_, { id, data }) => {
    try {
      const res = await axios.put(`product/${id}/update-history-quantity`, data)
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (err) {
      const { message } = getMessageFromError(err)
      return Promise.reject({ message })
    }
  },
  insertProduct: async ({ commit }, payload) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await axios.post('/product', payload)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },
  getProductById: async ({ commit }, id) => {
    try {
      const res = await axios.get(`/product/${id}`)
      commit('SET_STATE', {
        action: 'product',
        data: res.data.product
      })
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (err) {
      const { message } = getMessageFromError(err)
      return Promise.reject({ message })
    }
  },
  updateProduct: async ({ commit }, { id, data }) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await axios.put(`/product/${id}`, data)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({ message })
    }
  },
  removeProductImageById: async (_, id) => {
    try {
      const res = await axios.delete(`/product/${id}/delete-product-image`)
      return {
        message: res.data.message
      }
    } catch (err) {
      const { message } = getMessageFromError(err)
      return Promise.reject({ message })
    }
  },
  removeInventoryById: async (_, id) => {
    try {
      const res = await axios.delete(`/product/${id}/delete-inventory`)
      return {
        message: res.data.message
      }
    } catch (err) {
      const { message } = getMessageFromError(err)
      return Promise.reject({ message })
    }
  },
  removeDiscountById: async (_, id) => {
    try {
      const res = await axios.delete(`/product/${id}/delete-product-discount`)
      return {
        message: res.data.message
      }
    } catch (err) {
      const { message } = getMessageFromError(err)
      return Promise.reject({ message })
    }
  },
  getProductLabelDetails: async ({ commit }, id) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    try {
      const res = await axios.get(`/product/${id}/product-label`)

      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return {
        product: res.data.product,
        supplier: res.data.supplier,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({ message })
    }
  },
  updateProductLabelDetails: async ({ commit }, { id, data }) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    try {
      const res = await axios.put(`/product/${id}/product-label`, data)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({ message })
    }
  },
  // create or update product promotional discount
  async create_promotional_discount({ commit }, payload) {
    // start loading
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    // send create promotional discount request
    try {
      const res = await axios.post('/product/product-discount', payload)

      // stop loader
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      // return api response
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (err) {
      // stop loader
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      // manage error response
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },
  importCsv: async ({ commit }, payload) => {
    const accessToken = localStorage.getItem('accessToken')
    const options = {
      method: 'POST',
      url: '/product/import',
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer  ${accessToken}`
      },
      data: payload
    }
    try {
      commit('SET_STATE', {
        action: 'loading',
        data: true
      })
      const { data } = await axios.request(options)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return { message: data.message, data: data.products }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({ message })
    }
  },
  async updateProductPlants({ commit }, { id, data }) {
    // start loading
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    // send create promotional discount request
    try {
      const res = await axios.put(`/product/${id}/update-plants`, data)

      // stop loader
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      // return api response
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (err) {
      // stop loader
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      // manage error response
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // add new transfer
  addTransfer: async ({ commit }, payload) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    try {
      const res = await axios.post('/product/bulk-insert', payload)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      return {
        data: res.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  }
}
